import { ChangeDetectionStrategy, Component, computed, inject, output } from '@angular/core';
import { PctFormGroup } from '@pct-ng/form';
import { TranslocoDirective } from '@jsverse/transloco';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import {
  AbstractListFilterPanelComponent,
  ListFilterPanelWrapperComponent,
  SEARCH_TEXT_MAX_LENGTH_VALIDATOR,
} from '@cappus/shared-common';
import { CustomMatSvgIconDirective } from '@pct-ng/icon';
import { MatIcon } from '@angular/material/icon';
import { ForbiddenNicknameDtoService } from '../../../core/dto/forbidden-nickname/forbidden-nickname-dto.service';
import type {
  ForbiddenNicknameFilterForm,
  ForbiddenNicknameFilters,
  ForbiddenNicknameFiltersToBackend,
} from '../../../core/dto/forbidden-nickname/forbidden-nickname-filter';

@Component({
  selector: 'mecap-forbidden-nickname-list-filter-panel',
  imports: [
    TranslocoDirective,
    ReactiveFormsModule,
    MatButton,
    ListFilterPanelWrapperComponent,
    CustomMatSvgIconDirective,
    MatIcon,
  ],
  templateUrl: './forbidden-nickname-list-filter-panel.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [ForbiddenNicknameDtoService],
})
export class ForbiddenNicknameListFilterPanelComponent extends AbstractListFilterPanelComponent<
  ForbiddenNicknameFilterForm,
  ForbiddenNicknameFiltersToBackend
> {
  protected readonly i18nPrefix = computed(() => `${this.i18nParentPrefix()}.LIST`);
  protected clickOnNew = output();
  protected readonly service = inject(ForbiddenNicknameDtoService);

  protected override createForm(): PctFormGroup<ForbiddenNicknameFilterForm> {
    return new PctFormGroup<ForbiddenNicknameFilterForm>({
      searchText: new FormControl<ForbiddenNicknameFilters['searchText']>(null, {
        validators: SEARCH_TEXT_MAX_LENGTH_VALIDATOR,
      }),
    });
  }
}
